'use strict'

import './Pagen.css'
import React, { useEffect, useState } from 'react'

function Pagen (props) {
  const [path, setPath] = useState(window.location.pathname)
  const query_string = window.location.search

  const handlePageClick = (page, event) => {
    event.preventDefault(); // Предотвращаем стандартное действие перехода по ссылке

    const url = new URL(window.location.href);

    // Удаляем значение по маске "/page=*"
    url.pathname = url.pathname.replace(/\/page=[^\/]*/, '');

    //Устанавливаем параметр навигации
    url.pathname = `${url.pathname}page=${page}/`;

    const newUrl = url.toString();

    // Добавляем текущий URL в историю
    window.history.pushState({ url: newUrl }, null, newUrl);

    // Прокручиваем страницу к блоку с ID "blog-rubric-root"
    const blogRubricRoot = document.getElementById('blog-rubric-root');
    if (blogRubricRoot) {
      blogRubricRoot.scrollIntoView({ behavior: 'smooth' });
    }

    props.setLangLink(url.pathname);
    props.onPagerChange(page);
  }

  useEffect(() => {
    let clear_path = path
    clear_path = clear_path.replace(/page=\d+\//, '')
    setPath(clear_path)
  }, [])

  function makeNav () {
    let nav = []

    if (props.start > 1) {
      nav.push(<li key={'start'}><a href={`${path}${query_string.length ? '?' + query_string : ''}`}>1</a></li>)
      nav.push(<li key={'starting'}>...</li>)
    }

    for (let page = 1; page <= props.count; page++) {
      if ((page > props.count) && props.count > props.end) break

      if (page >= props.start && page <= props.end) {
        if (page === props.current) {
          nav.push(<li key={page} className="active"><span>{page}</span></li>)
        } else if (page === 1) {
          nav.push(<li key={page}>
            <a href={`${path}${query_string.length ? '?' + query_string : ''}`}
               onClick={(event) => handlePageClick(page, event)}
            >{page}</a>
          </li>)
        } else {
          nav.push(<li key={page}>
            <a
                href={`${path}page=${page}/${query_string.length ? '?' + query_string : ''}`}
                onClick={(event) => handlePageClick(page, event)}
            >{page}</a>
          </li>
          )
        }
      }
    }

    if (props.count > props.end) {
      nav.push(<li key={'ending'}>...</li>)
      nav.push(<li key={'end'}>
        <a href={`${path}page=${props.count}/${query_string.length ? '?' + query_string : ''}`}
           onClick={(event) => handlePageClick(props.count, event)}
        >{props.count}</a>
      </li>)
    }

    return nav
  }

  return (
    <ul className="pagen">{makeNav()}</ul>
  )
}

export default Pagen